import { useDashboard } from "../context/DashboardContext";
import { useDashboardActions } from "./useDashboardActions";

/**
 * Convenience hook for accessing and managing dashboard selections
 * (dealer and date range)
 */
export const useDashboardSelections = () => {
  const { state } = useDashboard();
  const { setSelectedDealer, setSelectedDateRange, setSelectedCompareEnabled, setSelectedCompareDateRange } = useDashboardActions();

  return {
    // State
    selectedDealer: state.selectedDealer,
    selectedDateRange: state.selectedDateRange,
    selectedCompareEnabled: state.selectedCompareEnabled,
    selectedCompareDateRange: state.selectedCompareDateRange,
    hydrated: state.hydrated,
    
    // Actions
    setSelectedDealer,
    setSelectedDateRange,
    setSelectedCompareEnabled,
    setSelectedCompareDateRange,
    
    // Computed
    hasDealer: !!state.selectedDealer,
    hasDateRange: !!state.selectedDateRange,
    isReady: state.hydrated && !!state.selectedDealer,
  };
};
